import { Component, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { RdsButtonModule, RdsEmptyStateModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-not-implemented',
  imports: [
    DynamicModule,
    StoryblokDirective,
    RdsEmptyStateModule,
    RdsButtonModule,
  ],
  templateUrl: './not-implemented.component.html',
  styleUrl: './not-implemented.component.scss'
})
export class NotImplementedComponent { 
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();
  content = input<any>();

  components = Components;

}
